import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import LabeledCheckbox from 'components/Checkbox/LabeledCheckbox';
import FormTextInput from 'components/FormTextInput/TypedFormTextInput';

import { type AppleWebConfig } from './types';

type AppleWebConfigCardProps = {
  config: AppleWebConfig;
  label: string;
  classes: { [key: string]: string };
  onChange: (config: AppleWebConfig) => void;
};

const AppleWebConfigCard = ({
  config,
  label,
  classes,
  onChange,
}: AppleWebConfigCardProps) => (
  <Card>
    <CardBody>
      <LabeledCheckbox
        checked={config.enabled}
        onChange={() => onChange({ ...config, enabled: !config.enabled })}
        label={label}
      />
      <FormTextInput
        label="Apple TEAM ID"
        classes={classes}
        name="appleTeamId"
        value={config.teamId}
        handleChange={e => onChange({ ...config, teamId: e.target.value })}
      />
      <FormTextInput
        label="Apple CLIENT ID"
        classes={classes}
        name="appleClientId"
        value={config.clientId}
        handleChange={e => onChange({ ...config, clientId: e.target.value })}
      />
      <FormTextInput
        label="Apple KEY FILE ID"
        classes={classes}
        name="appleKeyFileId"
        value={config.keyFileId}
        handleChange={e => onChange({ ...config, keyFileId: e.target.value })}
      />
      <FormTextInput
        label="Apple KEY FILE CONTENT"
        classes={classes}
        name="appleKeyFileContent"
        value={config.keyFileContent}
        handleChange={e =>
          onChange({ ...config, keyFileContent: e.target.value })
        }
        maxLength={1000}
        rows={6}
        multiline={true}
      />
      <FormTextInput
        label="Android bundle ID"
        classes={classes}
        name="appleAllowedSchemeRedirect"
        value={config.allowedSchemeRedirect}
        handleChange={e =>
          onChange({ ...config, allowedSchemeRedirect: e.target.value })
        }
      />
    </CardBody>
  </Card>
);

export default AppleWebConfigCard;
